import gql from 'graphql-tag'

export const updateThingTypeFamilyEligibilities = gql`
  mutation updateThingTypeFamilyEligibilities($updateData: [ThingTypeFamilyEligibilitiesInput!]!) {
    updateThingTypeFamilyEligibilities(input: { updateData: $updateData }) {
      success
    }
  }
`
